import React from "react";
import { Button } from "reactstrap";
import { Formik } from 'formik';
import Add from "../../../assets/icon/Add-White-Icon.svg"
import reset from "assets/icon/reset.svg";

const SearchContainer = (props) => {

    const {
        toggCommentDrawer,
        RefreshButton,
    } = props;

    return (
        <div>
        <Formik
            initialValues={''}
            onSubmit={toggCommentDrawer}
            enableReinitialize={true}
            children={() => {

                return (
                    <div>

                        
                        <div className="d-flex justify-content-between">
                        {/* <Button
                            color='primary'
                            className='ms-3 d-flex justify-content-left'
                            onClick={RefreshButton}
                            style={{marginRight:"auto"}}
                        >
                            Refresh
                        </Button> */}
                         <h5 className="f-16 text-primary font-weight-700" style={{alignContent:"center"}}>
Reports              </h5>
<div>
    <Button color="primary" className="reset" style={{marginRight:"10px"}} 
    onClick={RefreshButton}
        >
                  <span className="right_5">
                    <img src={reset} alt="" />
                  </span>{" "}
                  
                </Button>
                   <Button
                            color='primary'
                            className='search'
                            onClick={toggCommentDrawer}
                        >
                            <span className='right_5'> <img src={Add} alt="" /></span>
                            {" "}
                            Create Report
                        </Button>
</div>
                     
                        </div>
                      
                    </div>
                );
                
                
            }}
        ></Formik>
       
        </div>
        
    );
    
};

export default SearchContainer;